import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, message, Spin } from "antd";
import SidebarLayoutConsumer from './SidebarLayoutConsumer';
import { ClockCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, WalletOutlined, } from '@ant-design/icons';
import _AdministratorService from '../../../modules/AdministratorService';
import { COMMON_ERROR_MSG } from '../../../constants/constants';
import _commonService from '../../../modules/commonService';
import moment from "moment";
import ApplicationListConsumerPortal from './ApplicationListConsumerPortal';
import { useLocation } from "react-router-dom";
const { Title, Text } = Typography;

const AdministratorDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [bankerMonthlySummaryData, setBankerMonthlySummaryData] = useState([]);
    const BankerFirstName = localStorage.getItem("administratorFirstName");
    const [bankerName] = useState(BankerFirstName);
    const adminiStratorIdRaw = localStorage.getItem("administratorUserId");
    const administratorId = adminiStratorIdRaw ? parseInt(adminiStratorIdRaw) : null;
    const [loanApplications, setLoanApplications] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [applicationStatus, setApplicationStatus] = useState();

    const location = useLocation();
    let data = location.state;
    let appStatusFlag = 0;
    if (data && data.applicationStatusFlag) {
        appStatusFlag = data.applicationStatusFlag;
    }

    const [applicationStatusFilter] = useState(appStatusFlag);


    useEffect(() => {
        setApplicationStatus(applicationStatusFilter);
    }, [applicationStatusFilter]);

    useEffect(() => {
        getAllLoanApplicationListByBankerId();
    }, [debouncedSearchText, applicationStatus, toDate, sortBy, pageIndex, pageSize]);


    useEffect(() => {
        if (debouncedSearchText !== "") {
            setPageIndex(1);
            setPageSize(10);
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchTerm && searchTerm.trim());
        }, 900);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const getAllLoanApplicationListByBankerId = async () => {
        if ((applicationStatus != undefined || applicationStatus == 0)) {
            const params = {
                bankerId: administratorId,
                ByAppStatus: applicationStatus,
                startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
                endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
                pageIndex,
                pageSize,
                searchTerm: debouncedSearchText,
                sortBy,
                sortAsc: true,
            };
            setLoading(true);
            try {
                const resObj = await _AdministratorService.getAllLoanApplicationListByBankerId(params);

                if (
                    resObj?.data?.IsSuccess &&
                    resObj.data.Obj &&
                    Array.isArray(resObj.data.Obj.List)
                ) {
                    setLoanApplications(resObj.data.Obj.List);
                    setTotalCount(resObj.data.Obj.TotalRecords || 0);
                } else {
                    message.error(resObj.data.Message || COMMON_ERROR_MSG)
                }
            } catch (error) {
                console.error("Error fetching loan applications:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleClearFilters = () => {
        setSearchTerm("");
        setFromDate(null);
        setToDate(null);
        setSortBy(null);
        setApplicationStatus(0);
        setPageIndex(1);
        setPageSize(10);
    };

    const handlePaginationChange = (page, size) => {
        setPageIndex(page);
        setPageSize(size);
    };


    useEffect(() => {
        getAdministratorDataById(administratorId)
    }, []);

    const getAdministratorDataById = async () => {
        try {
            setLoading(true);

            const res = await _AdministratorService.getBankerDashboardSummaryByBankerId(administratorId);

            if (res.data.IsSuccess) {
                setBankerMonthlySummaryData(res?.data?.Obj.monthlySummary);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const currentMonthYear = _commonService.getCurrentMonthAndYear();

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <Row gutter={[0, 32]} className='capital-provider-dashboard' >
                    <Col span={24}>
                        <Title level={3}>Hello, {bankerName}!</Title>
                        <Title level={5}>Monthly Summary, {currentMonthYear}</Title>
                    </Col>
                    <Col span={24}>

                        {/* <Title level={3}>Hello, {bankerName}!</Title>
                <Title level={5}>Monthly Summary, {currentMonthYear}</Title> */}
                        <Row gutter={[24, 24]} justify="start" className=' banker-dashboard'>

                            {/* <Col xs={24} sm={12} md={8} lg={4}>
                        <Card className='cardStyle' bodyStyle={{ minHeight: 100 }}>
                            <div className='iconWrapStyle'>
                                <CloseCircleTwoTone twoToneColor="#3570EC" />
                            </div>
                            <Text>Unreviewed</Text>
                            <br />
                            <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                                {bankerMonthlySummaryData && bankerMonthlySummaryData.UnreviewedApplication}
                            </Title>
                        </Card>
                    </Col> */}

                            {/* <Col xs={24} sm={12} md={8} lg={6}>
                                <Card className="cardViewMain" bodyStyle={{ minHeight: 100 }}>
                                    <div className='iconWrapStyle'>
                                        <ClockCircleTwoTone twoToneColor="#3570EC" />
                                    </div>
                                    <Text>In-Progress</Text>
                                    <br />
                                    <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                                        {bankerMonthlySummaryData && bankerMonthlySummaryData.InProgressApplication}
                                    </Title>
                                </Card>
                            </Col> */}


                            <Col xs={24} sm={12} md={12} lg={6}>
                                <Card className='cardViewMain'>
                                    <div className='title-icon'>
                                        <Text>In-Progress</Text>
                                        <div className='cp-iconWrapStyle'>
                                            <ClockCircleOutlined style={{ color: '#3b82f6', fontSize: 20 }} />
                                        </div>
                                    </div>
                                    <div className='text-data'>
                                        <Title level={3}>
                                            {bankerMonthlySummaryData && bankerMonthlySummaryData.InProgressApplication}
                                        </Title>
                                        <Text>Applications under review</Text>
                                    </div>
                                </Card>
                            </Col>



                            {/* <Col xs={24} sm={12} md={8} lg={6}>
                                <Card className="cardViewMain" bodyStyle={{ minHeight: 100 }}>
                                    <div className='iconWrapStyle'>
                                        <LikeTwoTone twoToneColor="#3570EC" />
                                    </div>
                                    <Text>Qualified</Text>
                                    <br />
                                    <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                                        {bankerMonthlySummaryData && bankerMonthlySummaryData.RecommendedApplication}
                                    </Title>

                                </Card>
                            </Col> */}

                            <Col xs={24} sm={12} md={6}>
                                <Card className='cardViewMain'>
                                    <div className='title-icon'>
                                        <Text>Qualified</Text>
                                        <div className='cp-iconWrapStyle'>
                                            <CheckCircleOutlined style={{ color: '#22c55e', fontSize: 20 }} />
                                        </div>
                                    </div>
                                    <div className='text-data'>
                                        <Title level={3}>
                                            {bankerMonthlySummaryData && bankerMonthlySummaryData.RecommendedApplication}
                                        </Title>
                                        <Text>Applications marked eligible</Text>
                                    </div>
                                </Card>
                            </Col>

                            {/* <Col xs={24} sm={12} md={8} lg={6}>
                                <Card className="cardViewMain" bodyStyle={{ minHeight: 100 }}>
                                    <div className='iconWrapStyle'>
                                        <CloseCircleTwoTone twoToneColor="#3570EC" />
                                    </div>
                                    <Text>Not Qualified</Text>
                                    <br />
                                    <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                                        {bankerMonthlySummaryData && bankerMonthlySummaryData.NotQualified}
                                    </Title>
                                </Card>
                            </Col> */}

                            <Col xs={24} sm={12} md={6}>
                                <Card className='cardViewMain'>
                                    <div className='title-icon'>
                                        <Text>Not Qualified</Text>
                                        <div className='cp-iconWrapStyle'>
                                            <CloseCircleOutlined style={{ color: '#60a5fa', fontSize: 20 }} />
                                        </div>
                                    </div>
                                    <div className='text-data'>
                                        <Title level={3}>
                                            {bankerMonthlySummaryData && bankerMonthlySummaryData.NotQualified}
                                        </Title>
                                        <Text>Rejected applications</Text>
                                    </div>
                                </Card>
                            </Col>

                            {/* <Col xs={24} sm={12} md={8} lg={6}>
                                <Card className="cardViewMain" bodyStyle={{ minHeight: 100 }}>
                                    <div className='iconWrapStyle'>
                                        <CheckCircleTwoTone twoToneColor="#3570EC" />
                                    </div>
                                    <Text>Funded</Text>
                                    <br />
                                    <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                                        {bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApproved}
                                    </Title>
                                </Card>
                            </Col> */}

                            <Col xs={24} sm={12} md={6}>
                                <Card className='cardViewMain'>
                                    <div className='title-icon'>
                                        <Text>Funded</Text>
                                        <div className='cp-iconWrapStyle'>
                                            <WalletOutlined style={{ color: '#22c55e', fontSize: 20 }} />
                                        </div>
                                    </div>
                                    <div className='text-data'>
                                        <Title level={3}>
                                            {bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApproved}
                                        </Title>
                                        <Text>Fully approved and disbursed</Text>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <div style={{ marginBottom: 24 }}>

                            <ApplicationListConsumerPortal
                                allApplications={loanApplications}
                                loading={loading}
                                pageIndex={pageIndex}
                                pageSize={pageSize}
                                totalCount={totalCount}
                                onPaginationChange={handlePaginationChange}
                                searchTerm={searchTerm}
                                fromDate={fromDate}
                                toDate={toDate}
                                sortBy={sortBy}
                                onSearchChange={setSearchTerm}
                                fromDateChange={setFromDate}
                                toDateChange={setToDate}
                                onSortChange={setSortBy}
                                onClearFilters={handleClearFilters}
                                // onApplicationStatusChange={setApplicationStatus}
                                onApplicationStatusChange={(status) => {
                                    setApplicationStatus(status);
                                    setPageIndex(1);
                                    setPageSize(10);
                                }}
                                applicationStatusForFilter={applicationStatus}
                            />
                        </div>
                    </Col>
                </Row>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default AdministratorDashboard;